  <div>
      <p class="password-hints">
        <span 
        [class.met]="hasLowerCaseMet" 
        [class.not-met]="!hasMetMinCharLength && userHasTyped"
      >
        Minimum 8 characters
      </span>
      
      <span 
        [class.met]="hasLowerCaseMet" 
        [class.not-met]="!hasLowerCaseMet && userHasTyped"
      >
        • 1 lowercase 
      </span>
      <span 
        [class.met]="hasUpperCaseMet" 
        [class.not-met]="!hasUpperCaseMet && userHasTyped"
      >
        • 1 uppercase 
      </span>
      <span 
        [class.met]="hasDigitMet" 
        [class.not-met]="!hasDigitMet && userHasTyped"
      >
        • 1 digit 
      </span>
      <span 
        [class.met]="hasSpecialCharMet" 
        [class.not-met]="!hasSpecialCharMet && userHasTyped"
      >
        • 1 special character 
      </span>
    </p>
  </div>
  